import {
  apiRequest,
  dokumenPensiunCreate,
  dokumenPensiunListPension,
  dokumenPensiunListStop,
} from "../../../../../services/adapters/master/dokumenPensiunService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      dokumenPensiunCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchTypePension = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListPension,
      {
        params: query,
      },
      true
    );
  };

  fetchTypeStop = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListStop,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
